import UPLinkButton from './UPLinkButton';

export default UPLinkButton;
